'use client';

import React from 'react';

import { Body, Caption } from '@depop/web-thrift-ui/Typography';
import { Avatar, AVATAR_SIZE } from '@depop/web-ui-kit/Avatar';
import { useResponsive } from '@depop/web-ui-kit/useResponsive';

import styles from './styles.module.css';

import { ExtendedLink } from '@/components/ExtendedLink';
import { FeedbackStars } from '@/components/FeedbackStars';
import { getNearestSizePictureFormat } from '@/modules/pictures/helpers';
import { type BatchShopByUsernameResponse } from '@/modules/shop/types';

type Props = {
  onClick: (e: React.MouseEvent) => void;
} & BatchShopByUsernameResponse;

export function SellerNavigationItem({
  username,
  reviews_total,
  reviews_rating,
  initials,
  products = [],
  picture,
  verified,
  onClick,
}: Props) {
  const { isMaxSmall } = useResponsive();
  const THUMBNAIL_FORMAT_SIZE = 154;

  function getProductPicture(productIndex: number) {
    return getNearestSizePictureFormat(
      products?.[productIndex].preview?.[0],
      THUMBNAIL_FORMAT_SIZE
    )?.url;
  }

  return (
    <div className={styles.container}>
      <ExtendedLink href={`/${username}`} onClick={onClick}>
        <div className={styles.picturePanels}>
          <img
            className={styles.topLeftPicture}
            src={getProductPicture(0)}
            alt=""
          />
          <img
            className={styles.bottomLeftPicture}
            src={getProductPicture(1)}
            alt=""
          />
          <img
            className={styles.rightPicture}
            src={getProductPicture(1)}
            alt=""
          />
        </div>
        <div className={styles.shopInfo}>
          <div className={styles.avatarWrapper}>
            <Avatar
              src={picture ? picture['75'] : undefined}
              initials={initials}
              size={isMaxSmall ? AVATAR_SIZE.SMALL : AVATAR_SIZE.MEDIUM}
              verified={verified}
            />
          </div>
          <Body variant="sm-bold" className={styles.shopName}>
            {username}
          </Body>
          <div className={styles.feedbackContainer}>
            <FeedbackStars rating={reviews_rating} />
            <Caption variant="lg-regular" className={styles.reviewCount}>
              ({reviews_total})
            </Caption>
          </div>
        </div>
      </ExtendedLink>
    </div>
  );
}
